import {UpdatedEtsyListing} from '@coolcolduk/etsy';
import getAxios from '../axios/getAxios';

export interface UpdateEtsyListingRequest {
  /** listing id */
  id: number;
  title: string;
  tags: string[];
}

/**
 * Fetch listings by shop using the Axios client.
 * @param token - token for our api
 * @param accessToken - etsy access token
 * @param shopId - shop to fetch data from
 * @param params - Query parameters for the API.
 * @returns The listings response.
 */
export const updateAllListingsByIds = async (
  token: string,
  shopRecordId: string,
  updateData: UpdateEtsyListingRequest[],
): Promise<UpdatedEtsyListing[]> => {
  const response = await getAxios('etsy', {token}).post<UpdatedEtsyListing[]>(`updateMultiListingSeo`, {
    shopRecordId,
    updateData,
  });

  return response.data;
};
